<template>
  <div class="d-flex flex-grow">
    <div class="d-flex justify-content-center align-items-center flex-grow">
      <div class="login-wrapper col-xs-10 col-sm-7 col-md-6 col-3">
        <div class="text-center">
          <router-link class="logo-router" :to="{name: 'Homepage'}">
            <img class="rounded logo-img" src="@/assets/images/umoney_logo.png">
          </router-link>
        </div>

        <br>
        <br>

        <div v-if="this.getErrorMsg('form').length > 0" class="toast rounded">
          <p v-for="(message, i) in this.getErrorMsg('form')" :key="i">{{ message }}</p>
        </div>

        <br>

        <form @submit.prevent="onSubmit">
          <div class="form-group has-icon-left">
            <div class="vert-line"></div>
            <input
              class="form-input form-input--margin rounded focus-purple"
              type="text"
              v-bind:placeholder="this.getCaption('caption.email')"
              v-on:input="onChangeHandler('email', $v.email)"
              :class="{ 'is-error': $v.email.$error }"
              v-model="email"
            >
            <i class="form-icon form-icon--left fas fa-user"></i>
          </div>
          <div class="lined-error-msg" v-if="!$v.email.serverFailed">
            <span class="error-msg__data">{{ this.getErrorMsg('email')[0] }}</span>
          </div>

          <br>

          <div class="form-group has-icon-left">
            <div class="vert-line"></div>
            <input
              class="form-input form-input--margin rounded focus-purple"
              type="password"
              v-bind:placeholder="this.getCaption('caption.password')"
              v-on:input="onChangeHandler('password', $v.password)"
              :class="{ 'is-error': $v.password.$error }"
              v-model="password"
            >
            <i class="form-icon form-icon--left fas fa-lock"></i>
          </div>
          <div class="lined-error-msg" v-if="!$v.password.serverFailed">
            <span class="error-msg__data">{{ this.getErrorMsg('password')[0] }}</span>
          </div>

          <div class="form-group">
            <label class="form-checkbox form-inline">
              <input v-model="rememberMe" type="checkbox">
              <i class="form-icon"></i>
              {{ this.getCaption('caption.remember_me') }}
            </label>
            <router-link to="/forgotpassword">
              <span
                class="btn btn-link--purple float-right"
              >{{ this.getCaption('caption.forgot_password') }}</span>
            </router-link>
          </div>

          <br>

          <div class="form-group">
            <button
              type="submit"
              class="btn btn--color-orange btn--width-full rounded"
              :disabled="submitStatus === 'PENDING'"
            >
              <div v-if="submitStatus === 'PENDING'" class="loader--sm"></div>
              <span v-else>{{ this.getCaption("caption.login_button") }}</span>
            </button>
          </div>

          <br>

          <div class="form-group">
            <router-link to="/signup">
              <button
                type="button"
                class="btn btn--color-purple btn--width-full rounded"
              >{{ this.getCaption('caption.register_button') }}</button>
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/UserService";
import Form from "@/mixins/Form.js";
import { required } from "vuelidate/lib/validators";

export default {
  name: "SignIn",

  mixins: [Form],

  created() {
    if (localStorage.hasOwnProperty("rememberedEmail")) {
      let rememberedEmail = localStorage.getItem("rememberedEmail");
      this.email = rememberedEmail;
      this.rememberMe = true;
    }
  },

  data() {
    return {
      email: "",
      password: "",
      rememberMe: false
    };
  },

  validations: {
    email: {
      required,
      serverFailed: function() {
        return !this.hasServerError("email");
      }
    },
    password: {
      required,
      serverFailed: function() {
        return !this.hasServerError("password");
      }
    }
  },

  mounted() {
    this.$store.dispatch(
      "setPageTitle",
      this.getCaption("caption.login_button")
    );
  },

  methods: {
    serverRequest: UserService.signIn,

    successHandler(response) {
      this.$store.dispatch("setUser", response.data.payload);
      localStorage.setItem("isUserLogged", true);
      if (this.rememberMe) localStorage.setItem("rememberedEmail", this.email);
      else localStorage.removeItem("rememberedEmail");
      this.$router.push("/");
    },

    createJsonData() {
      const data = JSON.parse("{}");
      data.email = this.email;
      data.password = this.password;
      return data;
    }
  }
};
</script>